import {http, HttpResponse} from "msw";
import {waitTime} from "@shared/mocks/wait-time";

// Каталог по кодам аварий эмулятора (stationMock/MQTT-METRICS.md §8.1),
// привязан к реальному составу оборудования демонстрационного объекта №1 (§9).
const errors: Record<string, any> = {
    "a1b2c3d4-e5f6-4789-8123-456789abcdef": {
        "created_at": 1746400000000,
        "updated_at": 1746400500000,
        "is_resolved": false,
        "message": {
            "id": "a1b2c3d4-e5f6-4789-8123-456789abcdef",
            "code": "E201002",
            "level": "CRITICAL",
            "description": "Ток выше уставки максимума.",
            "full_description": "Потребляемый ток превысил SET_CURRENT_MAX. Вероятная причина — заклинивание рабочего колеса или перегрузка насоса.",
            "recommendations": "Остановить насос, проверить рабочее колесо и подводящий трубопровод на засор.",
            "metadata": {
                "station": "Демонстрационный объект №1",
                "device_id": "airMasterPro.1/returnRecyclePumpGroup.1/pump.2",
                "device_name": "Насос рециркуляции №2, линия биоочистки 1"
            }
        }
    },
    "b2c3d4e5-f6a7-4890-9123-56789abcdef0a": {
        "created_at": 1746395000000,
        "updated_at": 1746395500000,
        "is_resolved": true,
        "message": {
            "id": "b2c3d4e5-f6a7-4890-9123-56789abcdef0a",
            "code": "E201005",
            "level": "WARNING",
            "description": "Давление выше уставки максимума.",
            "full_description": "Избыточное давление в коллекторе превысило SET_OVERPRESSURE_MAX — признак забивания напорной линии воздуходувки.",
            "recommendations": "Проверить проходимость воздуховода и состояние обратного клапана.",
            "metadata": {
                "station": "Демонстрационный объект №1",
                "device_id": "blowerModule.1/blower.1",
                "device_name": "Воздуходувка №1, воздуходувный модуль"
            }
        }
    },
    "c3d4e5f6-a7b8-4901-0123-6789abcdef01a": {
        "created_at": 1746390000000,
        "updated_at": 1746391000000,
        "is_resolved": false,
        "message": {
            "id": "c3d4e5f6-a7b8-4901-0123-6789abcdef01a",
            "code": "E201007",
            "level": "INFO",
            "description": "Перепад давления на фильтре выше уставки.",
            "full_description": "Разница давлений до и после фильтра превысила SET_OVERPRESSURE_DELTA — фильтр постепенно забивается.",
            "recommendations": "Запланировать промывку либо замену загрузки фильтра.",
            "metadata": {
                "station": "Демонстрационный объект №2",
                "device_id": "altaBioClean.1/filter.1",
                "device_name": "Фильтр механический, узел доочистки"
            }
        }
    },
    "d4e5f6a7-b8c9-4012-1234-789abcdef012a": {
        "created_at": 1746385000000,
        "updated_at": 1746386000000,
        "is_resolved": true,
        "message": {
            "id": "d4e5f6a7-b8c9-4012-1234-789abcdef012a",
            "code": "E201015",
            "level": "WARNING",
            "description": "Отказ датчика — недостоверные показания.",
            "full_description": "Датчик перестал выдавать достоверные значения: показание зафиксировано на последнем известном уровне.",
            "recommendations": "Проверить показания по резервному каналу, выполнить поверку или замену датчика.",
            "metadata": {
                "station": "Демонстрационный объект №1",
                "device_id": "airMasterPro.2/ph",
                "device_name": "Датчик pH, линия биологической очистки №2"
            }
        }
    },
    "e5f6a7b8-c9d0-4123-2345-89abcdef0123a": {
        "created_at": 1746380000000,
        "updated_at": 1746381000000,
        "is_resolved": false,
        "message": {
            "id": "e5f6a7b8-c9d0-4123-2345-89abcdef0123a",
            "code": "E201000",
            "level": "CRITICAL",
            "description": "Отказ устройства.",
            "full_description": "Устройство перестало отвечать на команды управления, STATE зафиксирован в положении до отказа.",
            "recommendations": "Проверить электропитание и цепи управления, при необходимости привлечь сервисную службу.",
            "metadata": {
                "station": "Демонстрационный объект №1",
                "device_id": "sludgeTreatmentUnit.1/dewaterer.1",
                "device_name": "Обезвоживатель №1, узел обезвоживания осадка"
            }
        }
    },
    "f6a7b8c9-d0e1-4234-3456-9abcdef01234a": {
        "created_at": 1746375000000,
        "updated_at": 1746375600000,
        "is_resolved": false,
        "message": {
            "id": "f6a7b8c9-d0e1-4234-3456-9abcdef01234a",
            "code": "E201009",
            "level": "CRITICAL",
            "description": "Аварийный уровень в ёмкости.",
            "full_description": "Уровень в приёмной камере достиг отметки ALARM_LEVEL — при сохранении притока возможен перелив на площадку мехочистки.",
            "recommendations": "Убедиться, что оба насоса приёмной камеры включены, при необходимости запустить резервный насос вручную.",
            "metadata": {
                "station": "Демонстрационный объект №2",
                "device_id": "preTreatmentUnit.1/pumpingUnit.1",
                "device_name": "Приёмная камера, узел предварительной мехочистки"
            }
        }
    }
};

const apiUrl = "*/api/v2";
const errorsUrl = apiUrl + "/errors/stations/:id";

const getErrors = http.get(errorsUrl, async ({request}) => {
    const url = new URL(request.url);
    const level = url.searchParams.get("level");
    const isResolved = url.searchParams.get("is_resolved");
    const count = Number(url.searchParams.get("count")!);
    const offset = Number(url.searchParams.get("offset")!);

    const entities = Object.values(errors)
        .filter(err => level ? level === err.message.level : true)
        .filter(err => isResolved ? isResolved === String(err.is_resolved) : true);

    await waitTime(1000);
    return HttpResponse.json({
        page_number: 1,
        page_size: 5,
        total_pages: 1,
        total_elements: 5,
        last: true,
        empty: false,
        content: entities.slice(offset, count + offset)
    });
});

export const errorsHandlers = [
    getErrors,
];
